// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

import Capsule from "../assets/icons/capsule.svg";

const icons = {
  casDeComptoir: () => (
    <img
      src={Capsule}
      alt="cas de comptoir icon"
      style={{ width: 24, height: 24 }}
    />
  ),
};
// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const casDeComptoir = {
  id: "casDeComptoir",
  title: <FormattedMessage id="casDeComptoir" />,
  type: "group",
  url: "#",
  icon: icons.casDeComptoir,
  disabled: true,
};

export default casDeComptoir;
